
define('text!modules/strategy/supply/open/templates/bin_title.html',[],function () { return '<div class="header-c title" data-bind="{{bin_kind}}-count">Supply Sources: <span data-bind="optional_amount">{{optional_amount}}</span></div>\n';});

